module.exports = __webpack_public_path__ + "img/box-stacked.76e33821.svg";